import { NgModule } from '@angular/core';
import { CartRealtimeMessageComponent } from './icon/cart-realtime-message.component';
import { CartIconDirective } from './icon/cart-icon.directive';

@NgModule({
    declarations: [
        CartRealtimeMessageComponent,
        CartIconDirective
    ],
    providers: [],
    imports: [],
    exports: [
        CartRealtimeMessageComponent,
        CartIconDirective
    ]
})
export class CartModule {}
